export const positions = {
  namespaced: true,
  state: {
    list: [{ name: 'Student', code: 'student' }],
    dictionary: {
      student: 'Student',
    },
  },
}
